import { useCallback } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { useAuth } from '@/contexts/AuthContext';

// Telegram Pixel event ID
const TELEGRAM_PIXEL_EVENT_ID = 'GpT0BnGG-6TSfd85N';

// Declare global tgp function
declare global {
  interface Window {
    tgp?: (action: string, eventId: string) => void;
  }
}

interface TrackEventParams {
  buttonLocation: string;
  pageMode: 'wallet' | 'explorer' | 'banner';
}

export const useTelegramPixel = () => {
  const { user } = useAuth();

  const trackAppDownloadClick = useCallback(async (params: TrackEventParams) => {
    try {
      // 1. Fire Telegram Pixel event
      if (typeof window !== 'undefined' && window.tgp) {
        window.tgp('event', TELEGRAM_PIXEL_EVENT_ID);
        console.log('Telegram Pixel event fired:', TELEGRAM_PIXEL_EVENT_ID);
      }

      // 2. Store event in database with geo info
      const { data, error } = await supabase.functions.invoke('admin', {
        body: {
          action: 'track_pixel_event',
          event_id: TELEGRAM_PIXEL_EVENT_ID,
          event_type: 'app_download_click',
          button_location: params.buttonLocation,
          page_mode: params.pageMode,
          referrer: document.referrer || null,
          user_agent: navigator.userAgent,
          user_id: user?.id || null,
        }
      });

      if (error) {
        console.error('Failed to track pixel event:', error);
      } else {
        console.log('Pixel event tracked:', data);
      }
    } catch (err) {
      console.error('Error tracking app download click:', err);
    }
  }, [user?.id]);

  return { trackAppDownloadClick };
};
